<template>
    <div class="history-container">
        <datepicker v-if="!isLoading" v-model="date"
            :language="getDatepickerLanguage"
            :monday-first="true"
            :bootstrap-styling="true"
            :clear-button="true"
            :disabled="isLoading"
            format="yyyy-MM-dd">
        </datepicker>
        <b-card v-for="ticket in tickets" :key="ticket.id" class="mb-4">
          <ticket
              :ticket="ticket"
              :iteration="iteration"
              :game-name="gameName"/>
        </b-card>
        <div class="text-center pb-3">
            <span v-if="!tickets.length && !isLoading">{{ 'no_history' | lang }}</span>
            <fa-icon v-if="isLoading" icon="spinner" size="3x" spin></fa-icon>
            <button @click="fetch" v-else-if="!hasEnded && tickets.length"><fa-icon icon="ellipsis-h"></fa-icon> {{ 'more' | lang }}</button>
        </div>
    </div>
</template>

<script>
import Axios from "axios";
import Datepicker from 'vuejs-datepicker';
import {en, lt, fr, sk} from 'vuejs-datepicker/dist/locale';
import Ticket from './Ticket.vue';

export default {
    components: { Datepicker, Ticket },
    data() {
        return {
            date: moment().format('YYYY-MM-DD'),
            tickets: [],
            isLoading: false,
            skip: 0,
            hasEnded: false,
            reels: Config.reels,
            gameName: Config.game_name.toLowerCase(),
            language: Config.language,
            height: Config.reels_height,
            width: Config.reels_width,
            iteration: Config.iteration,
            datepickerLanguages: {
                en, lt, fr, sk,
            }
        }
    },
    computed: {
        getDatepickerLanguage() {
            if(this.datepickerLanguages[this.language]){
                return this.datepickerLanguages[this.language];
            }
            
            return this.datepickerLanguages['en'];
        },
    },
    methods: {
        async fetch() {
            this.isLoading = true;

            const params = {
                skip: this.skip,
                shop_id: Config.shop_id,
                game_id: Config.game_id,
                date: this.date ? moment(this.date).format('YYYY-MM-DD') : undefined,
            };

            try {
                const { data: retrieved } = await Axios.get(Config.route.history , { params });

                const res = retrieved.blob ? JSON.parse(atob(retrieved.blob)) : retrieved;
    
                if (res.success) {
                    this.tickets.push(...res.tickets);
                    this.skip += res.tickets.length;
                    this.hasEnded = res.end;
                }
            } catch (err) {
                console.error(err);
            }

            this.isLoading = false;
        },

        reset() {
            this.tickets = [];
            this.skip = 0;
            this.hasEnded = false;
            this.fetch();
        }
    },
    watch: {
        date() {
            this.reset();
        },
    },

    created() {
        this.reset();
    },
}
</script>